export default __webpack_public_path__ + "static/media/sem1.25b05925.JPG";